import React from 'react';
import { Box, IconButton, Typography, Chip } from '@mui/material';
import { ArrowBackIosNewRounded } from '@mui/icons-material';

// One shared page-title treatment for every screen: optional back button,
// optional accent icon/dot, optional date chip (editable or read-only —
// these must look visually different so a read-only chip never implies
// tappability it doesn't have), optional trailing action.
//
// variant="auth" renders the centered large-title style used by Login/Register.
export default function PageHeader({
  title,
  subtitle,
  onBack,
  icon,
  accentColor,
  dateChip,
  trailingAction,
  variant = 'default',
  sx,
}) {
  if (variant === 'auth') {
    return (
      <Box sx={{ textAlign: 'center', mb: 5, ...sx }}>
        <Typography variant="h4">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, ...sx }}>
      {onBack && (
        <IconButton onClick={onBack} edge="start" sx={{ ml: -1 }}>
          <ArrowBackIosNewRounded fontSize="small" />
        </IconButton>
      )}
      {icon && (
        <Box sx={{ display: 'flex', color: accentColor || 'primary.main', flexShrink: 0 }}>
          {icon}
        </Box>
      )}
      {!icon && accentColor && (
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: accentColor,
            flexShrink: 0,
          }}
        />
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="h5" noWrap>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {subtitle}
          </Typography>
        )}
      </Box>
      {dateChip && <DateChip {...dateChip} />}
      {trailingAction}
    </Box>
  );
}

// dateChip: { label, isoDate, editable, onChange }
function DateChip({ label, isoDate, editable = false, onChange }) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
      <Chip
        label={label}
        sx={{
          fontWeight: 600,
          ...(editable ? {} : { opacity: 0.55 }),
        }}
      />
      {editable && (
        <input
          type="date"
          value={isoDate}
          onChange={onChange}
          style={{
            position: 'absolute',
            inset: 0,
            opacity: 0,
            width: '100%',
            height: '100%',
            border: 'none',
            cursor: 'pointer',
          }}
        />
      )}
    </Box>
  );
}
